import { useEffect, useState } from 'react'
import {
   ContentBox,
   ContentTitle,
   FundraiserButton,
   FundraiserTitle,
   FundraisersName,
   ImageBox,
   ImageCol,
   Name,
   PersonalFundraisersBox,
   PersonalFundraisersSection
} from './myPersonalFundraisersStyle';
import { Button, Col, Image, Row } from 'react-bootstrap'
import { MESSAGE } from '../../../utils/message'
import RangeSlider from '../rangeSlider'
import { useSelector, useDispatch } from 'react-redux'
import { personalFundraiserHandler } from '../../../redux/slices/myAccount/personalFundraiser-slice'
import noImage from "../../../assests/images/gnp_noimg.png";
import SimpleLoader from '../simpleLoader/Loader';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { unpublishFundraiserHandler } from '../../../redux/slices/myAccount/manageFundraiser-slice';

const PersonalFundraiserList = () => {
   const { user_id } = useParams()
   const fundraiserInfo = useSelector((state: any) => state?.personalFundraiser?.data?.results)
  
   


   const dispatch: any = useDispatch()
   const { pathname } = useLocation()
   const [loader, setLoader] = useState(true);
   const [fundraisers, setFundraisers] = useState(fundraiserInfo || []);
   const navigate = useNavigate()
   const handleUnpublishFund = async (org_id: any) => {
        

      try {
         if (user_id && org_id) {
            await dispatch(unpublishFundraiserHandler(user_id,org_id));
            setFundraisers((prevFundraisers: any[]) =>
               prevFundraisers.map((fundraiser) =>
                  fundraiser?.org_id === org_id
                     ? { ...fundraiser, is_published: !fundraiser?.is_published }
                     : fundraiser
               )
            );
            // Refetch updated data after the unpublish/publish action
            await dispatch(personalFundraiserHandler(user_id));
         }
         navigate(`/users/profile/${user_id}/fundraisers/list`);
      } catch (error) {
         console.log(error);
      }
   }

   useEffect(() => {
      if (user_id) {
         setLoader(true);
         // Fetch personal fundraiser data and ensure the latest data is updated in the store
         dispatch(personalFundraiserHandler(user_id))
            .then((response: any) => {
               setFundraisers(response?.payload?.results || []); // Update local state
               setLoader(false);
            })
            .catch(() => setLoader(false));
      }
   }, [dispatch, user_id]);

   return (
      <PersonalFundraisersSection>
         <FundraiserTitle>{MESSAGE.myPersonalFundraisers}</FundraiserTitle>
         <Row>
            {loader ? (
               <div style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <SimpleLoader />
               </div>
            ) : (
               fundraiserInfo?.map((fundRaiser: any, index: any) => (

                  <Col lg={4} md={6} sm={12} key={index + 1}>
                     <PersonalFundraisersBox>
                        <ImageBox className='img-col'>
                           <Image src={fundRaiser?.image ? fundRaiser?.image : noImage} />
                           <FundraisersName>
                              <ImageCol className='user-img'>
                                 <Image src={fundRaiser?.profile_pic} alt={fundraiserInfo?.image} />
                              </ImageCol>
                              <Name>{fundRaiser?.title}</Name>
                           </FundraisersName>
                        </ImageBox>
                        <ContentBox>
                           <ContentTitle>{fundraiserInfo?.fundingFor}</ContentTitle>
                           <RangeSlider fundInfo={fundRaiser} />
                           <FundraiserButton>
                              <Button
                                 className="btn-outline-success-blue"
                                 onClick={() => navigate(pathname.replace("list", `details/${fundRaiser?.review_id}`))}
                              >
                                 {MESSAGE.viewFundraiseDashboard}
                              </Button>
                              <Button className="btn-outline-success-blue" onClick={() => handleUnpublishFund(fundRaiser?.review_id)}>
                                 {fundRaiser?.is_published === true ? MESSAGE.unpublishFundraiser : MESSAGE.publishFundraiser}
                              </Button>

                           </FundraiserButton>
                        </ContentBox>
                     </PersonalFundraisersBox>
                  </Col>
               ))
            )}
         </Row>

      </PersonalFundraisersSection>
   )
}

export default PersonalFundraiserList
